var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"request-year"},[_c('v-select',{staticClass:"years-selector",attrs:{"options":_vm.years,"clearable":false},model:{value:(_vm.requestYear),callback:function ($$v) {_vm.requestYear=$$v},expression:"requestYear"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }